export default {
  portfolio: {
    title: 'Наши проекты',
    projects: {
      ai_valuation: 'AI-оценка недвижимости',
      price_prediction: 'Прогнозирование цен',
      district_analysis: 'Анализ рынка по районам',
      report_automation: 'Автоматизация отчётов',
      developer_api_integration: 'Интеграция с API застройщиков',
      investment_index: 'Индексы инвестиционной привлекательности'
    }
  }
}